import { ReactElement } from 'react';
import { Heading, Wrapper } from './About.elements';
import { Text } from '../../components/Text';
import {
  SiAmazonaws,
  SiGooglecloud,
  SiKotlin,
  SiNodedotjs,
  SiReact,
  SiTypescript,
} from 'react-icons/si';
import { JobHistory } from '../../components/JobHistory';
import { differenceInYears } from 'date-fns';

export const About = (): ReactElement => {
  return (
    <Wrapper>
      <section>
        <Heading>About Me</Heading>
        <Text tag="p">
          I have over {differenceInYears(Date.now(), '2014-03-01')} years of
          experience in various industries (including domains, gaming, third
          party logistics, and IoT) and different tech stacks, working closely
          with Product, Design and QA/QC teams across multiple projects.
        </Text>
        <br />
        <Text>
          I am a fast and keen learner, with a product focused and systems
          thinking mindset, and a passion for building great software.
        </Text>
      </section>
      <section>
        <Heading>Technical Skills</Heading>
        <Text>
          <SiKotlin /> <SiTypescript /> <SiNodedotjs /> <SiReact />{' '}
          <SiAmazonaws /> <SiGooglecloud />
        </Text>
        <ul>
          <li>Kotlin, Typescript, Javascript, Rust, Java, Golang</li>
          <li>NodeJS, Express</li>
          <li>React, Redux, CSS, Styled Components, Storybook</li>
          <li>PostgreSQL, MySQL</li>
          <li>AWS, GCP</li>
          <li>Docker</li>
          <li>Jest, Mocha, Junit, Playwright, Cypress</li>
          <li>Pulumi, Terraform</li>
          <li>CircleCI, Codefresh</li>
          <li>Functional programming, Object Oriented Programming</li>
          <li>Event sourcing, Event-driven Architecture</li>
        </ul>
        <Text size="small">
          I built this site using React with Styled Components!
        </Text>
      </section>
      <section>
        <Heading>Experience</Heading>
        <JobHistory
          employer="Atlassian"
          url="https://www.atlassian.com/"
          location="Remote"
          title="Software Engineer (P40)"
          startDate="MARCH 2025"
          endDate="Present"
          description={['Backend Engineer']}
        />
        <JobHistory
          employer="Transdigital"
          url="https://transdigital.com.au"
          location="Perth"
          title="Lead Javascript Developer"
          startDate="AUGUST 2023"
          endDate="JULY 2024"
          description={[
            'Developed features and improvements for the cloud based alarm monitoring system, which allows clients to monitor incoming alarms from their several thousand IoT alarm devices.',
            'Provided input into the design of new features and solutions for challenges as the product scales.',
          ]}
        />
        <JobHistory
          employer="SKUTOPIA"
          url="https://skutopia.com"
          location="Remote"
          title="Senior Software Engineer"
          startDate="DECEMBER 2021"
          endDate="AUGUST 2023"
          description={[
            'Senior Engineer and Squad Lead for the Fulfilment Squad, working closely with Product and Design teams across all projects in the squad.',
            'My team and I built their Warehouse Management System (WMS) for their Urban Robotics Fulfilment Centre from the ground up which is now used to fulfil thousands of orders every day.',
          ]}
        />
        <JobHistory
          employer="VGW"
          url="https://vgw.co"
          location="Perth"
          title="Software Engineer"
          startDate="OCTOBER 2018"
          endDate="DECEMBER 2021"
          description={[
            'Worked on the Chumba Casino platform which serves hundreds of thousands of players per day.',
            'Was a key part of the team that built a brand new lobby for the Casino platform, which enabled a 10x revenue increase.',
            'Led the migration of build pipelines from Jenkins to Codefresh CI.',
          ]}
        />
        <JobHistory
          employer="Dreamscape Networks"
          url="https://dreamscapenetworks.com"
          location="Perth"
          title="Java Development Manager"
          startDate="FEBRUARY 2014"
          endDate="OCTOBER 2018"
          description={[
            'Led a small team of Java developers working on backend systems that handled domain name registration for multiple brands within the Dreamscape Networks group.',
            'Developed improvements to legacy systems that saw a 5x improvement in system performance and improved capture rate of backordered domain names.',
          ]}
        />
      </section>
    </Wrapper>
  );
};
